import "./App.css";
import React, { useState, useEffect } from "react";
import Navbar from "./components/Navigation/Navbar";
import Home from "./components/Home/Home";
import Footer from "./components/Footer/Footer";
import About from "./components/About/About";
import Services from "./components/Services/Services";
import Contact from "./components/Contact/Contact";
import Portfolio from "./components/Portfolio/Portfolio";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import NamStack from "./components/images/logo.png";
import { EatLoading } from "react-loadingg";
import Aos from "aos";
import "aos/dist/aos.css";

// import ClipLoader from "react-spinners/ClipLoader";

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Initialize AOS animations
    Aos.init({
      duration: 800,
      easing: 'ease-in-out',
      once: false,
    });
    
    // Loading screen
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <div className="App">
      {loading ? (
        <div className="loader">
          <svg width="120" height="120" viewBox="0 0 120 120" className="loader-svg">
            <circle cx="60" cy="60" r="50" className="loader-circle" />
            <path className="loader-path" d="M60,10 A50,50 0 0,1 110,60" />
          </svg>
          <p className="loader-text">NamStack</p>
          <EatLoading size="small" speed={4} color="#2c3c54" />
        </div>
      ) : (
        <BrowserRouter>
            <Navbar />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/about" component={About} />
            <Route path="/services" component={Services} />
            <Route path="/contact" component={Contact} />
            <Route path="/portfolio" component={Portfolio} />
          </Switch>
            <Footer />
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
